"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _BaseLink = _interopRequireDefault(require("@components/BaseLink"));

var _scss = require("@scss");

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

var _excluded = ["links", "classes"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Breadcrumb = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$links = _ref.links,
      links = _ref$links === void 0 ? [] : _ref$links,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {
    wrapper: '',
    li: '',
    link: ''
  } : _ref$classes,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("nav", _extends({
    "aria-label": "breadcrumb",
    className: (0, _scss.cls)(classes['wrapper']),
    ref: ref
  }, props), /*#__PURE__*/_react["default"].createElement("ol", {
    className: (0, _scss.cls)(_stylesModule["default"]['breadcrumb']),
    itemScope: true,
    itemType: "https://schema.org/BreadcrumbList"
  }, links.map(function (item, i) {
    var isLast = links.length - 1 === i;
    return /*#__PURE__*/_react["default"].createElement("li", _extends({
      key: i,
      className: (0, _scss.cls)(_stylesModule["default"]['breadcrumb-item'], isLast && _stylesModule["default"]['active'], classes['li'])
    }, isLast && {
      'aria-current': 'page'
    }, {
      itemProp: "itemListElement",
      itemScope: true,
      itemType: "https://schema.org/ListItem"
    }), isLast ? /*#__PURE__*/_react["default"].createElement("span", {
      itemProp: "name"
    }, item.label) : /*#__PURE__*/_react["default"].createElement(_BaseLink["default"], _extends({}, item, {
      classes: {
        root: classes['link']
      },
      itemProp: "item",
      href: item.href,
      children: typeof item.label === 'string' ? /*#__PURE__*/_react["default"].createElement("span", {
        itemProp: "name"
      }, item.label) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, item.label, item.alt ? /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _scss.cls)('d-none'),
        itemProp: "name"
      }, item.alt) : null)
    })), /*#__PURE__*/_react["default"].createElement("meta", {
      itemProp: "position",
      content: i + 1
    }));
  })));
});
var _default = Breadcrumb;
exports["default"] = _default;